module.exports = __webpack_public_path__ + "media/svg-new/icon-avaliacoes-8dcc37fd.svg";